export const SLIDER_MARKS_MAP = {
  0   : '0',
  10  : '50M',
  20  : '100M',
  30  : '150M',
  40  : '200M',
  50  : '300M',
  60  : '500M',
  70  : '1G',
  80  : '2G',
  90  : '3G',
  100 : '5G',
  110 : '10G',
};

export const MOBILE_PROFIT_MAP = {
  0   : '0',
  10  : '101',
  20  : '201',
  30  : '302',
  40  : '402',
  50  : '603',
  60  : '1005',
  70  : '2010',
  80  : '4020',
  90  : '6030',
  100 : '10050',
  110 : '20100',
};

export const UNICOM_PROFIT_MAP = {
  0   : '0',
  10  : '134',
  20  : '268',
  30  : '402',
  40  : '536',
  50  : '804',
  60  : '1340',
  70  : '2680',
  80  : '5360',
  90  : '8040',
  100 : '13400',
  110 : '26800',
};

export const VIDEO_NUM_LINK_MAP = {
  1: 'a',
  2: 'a',
  3: 'a',
  4: 'a',
  5: 'a',
};


